<template>
  <div class="goal-list-progress-chart">
    <no-data v-if="!hasData" />
    <base-chart
      v-else
      :options="chartOptions"
    />
  </div>
</template>

<script setup>
import BaseChart from '@/components/dashboard/BaseChart.vue';
import NoData from '@/components/dashboard/NoData.vue';
import useGoalProgressChart from '@/composables/grid-page/chart/goal-progress-chart';
import { DateTime } from 'luxon';
import { computed } from 'vue';

const props = defineProps({
  startDate: {
    type: Date,
    required: true,
  },
  endDate: {
    type: Date,
    required: true,
  },
  chartData: {
    type: Array,
    default: () => [],
  },
});

const chartResult = computed(() => ({
  isTimeSeries: true,
  progressData: props.chartData,
  startDate: DateTime.fromJSDate(props.startDate),
  endDate: DateTime.fromJSDate(props.endDate),
}));

const { chartOptions, hasData } = useGoalProgressChart(chartResult);
</script>
